import { useNavigate, useSearchParams } from "react-router-dom";

import { useUpdateUserSettingsMutation } from "@/hooks/use-user-settings";
import { OnboardingDownloadApp } from "@/components/onboarding/onboarding-download-app";
import { OnboardingProgress } from "@/components/onboarding/onboarding-progress";
import { SkipButton } from "@/components/onboarding/skip-button";

export function OnboardingDownloadPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateSettings = useUpdateUserSettingsMutation();

  // Debug: ?done in the URL forces the success state.
  const showDoneState = searchParams.has("done");

  const handleSkip = () => {
    navigate("/");
  };

  const handleSuccess = () => {
    updateSettings.mutate({ onboarding_download: true });
  };

  return (
    <div className="space-y-8">
      <SkipButton href="/" fixed />

      <OnboardingProgress
        currentStep={2}
        title="Experience Appio from your users' perspective"
      />

      <OnboardingDownloadApp onSkip={handleSkip} onSuccess={handleSuccess} initialConnected={showDoneState} />
    </div>
  );
}
